import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Interaction } from 'src/app/pages/interactions/interaction.model';

@Component({
  selector: 'app-indovina-parola',
  templateUrl: './indovina-parola.component.html',
  styleUrls: ['./indovina-parola.component.scss']
})
export class IndovinaParolaComponent implements OnInit {

  @Input() interaction: Interaction;
  @Input() saveInExperience: boolean;
  @Output() addInteraction = new EventEmitter();

  indovinaParolaForm = new FormGroup({
    domanda: new FormControl('', [Validators.required]),
    sottotitolo: new FormControl(''),
    info: new FormControl(''),
    lat: new FormControl(''),
    lng: new FormControl(''),
    parola: new FormControl('', [Validators.required]),
  });

  constructor() { }

  ngOnInit(): void {
    if (this.interaction) { // devo riempire i field
      this.populateForm();
    } else {
      this.interaction = {interactionType: 'indovinaParola'};
    }
  }

  // convenience getter for easy access to form fields
  get f(): any {
    return this.indovinaParolaForm.controls;
  }

  populateForm(): void {
    this.f.domanda.setValue(this.interaction.title);
    this.f.sottotitolo.setValue(this.interaction.subtitle);
    this.interaction.interactionData && this.interaction.interactionData.info ? this.f.info.setValue(this.interaction.interactionData.info) : '';
    this.interaction.interactionData && this.interaction.interactionData.coordinates ? this.f.lat.setValue(this.interaction.interactionData.coordinates.lat) : '';
    this.interaction.interactionData && this.interaction.interactionData.coordinates ? this.f.lng.setValue(this.interaction.interactionData.coordinates.lng) : '';
    this.interaction.interactionData && this.f.parola.setValue(this.interaction.interactionData.risposta);
  }

  validateDomanda(): boolean {
    return !this.f.domanda.errors && !this.f.sottotitolo.errors;
  }

  setDomanda(): void {
    this.interaction.title = this.f.domanda.value;
    this.interaction.subtitle = this.f.sottotitolo.value;
  }

  onAddInteraction(): void {
    this.interaction.interactionData = {
      risposta: this.f.parola.value,
      info: this.f.info.value,
      coordinates: {
        lat: this.f.lat.value,
        lng: this.f.lng.value
      }
    };

    this.addInteraction.emit(this.interaction);
  }

}
